// extracted by mini-css-extract-plugin
module.exports = {"radio":"Radio_radio__Dc_Cl","lightRadio":"Radio_lightRadio___DpKO","label":"Radio_label__hw3oe","selected":"Radio_selected__TetOh"};